import { render, staticRenderFns } from "./GlobalAssessment.vue?vue&type=template&id=746b0840&scoped=true"
import script from "./GlobalAssessment.vue?vue&type=script&lang=js"
export * from "./GlobalAssessment.vue?vue&type=script&lang=js"
import style0 from "./GlobalAssessment.vue?vue&type=style&index=0&id=746b0840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b0840",
  null
  
)

export default component.exports